"use client";
import Image from "next/image";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { openModal } from "@/slice/whatsappModalSlice";

export default function HowItWorks() {
  const intl = useIntl();
  const dispatch = useDispatch();

  return (
    <>
      <div className="bg-[#FBFDFF] w-full -mt-6 lg:-mt-8">
        <div className="max-w-[1440px] mx-auto px-5 lg:px-[60px] lg:pt-0 lg:pb-12 pb-4">
          <div className="grid grid-cols-1 md:grid-cols-[1.2fr_0.9fr] gap-4 lg:gap-8 items-start">
            {/* LEFT COLUMN */}
            <div className="px-6 lg:px-0 lg:pl-[40px] pl-0 lg:pt-0">
              <h1 className="font-roboto-slab text-[20px] lg:text-[34px] text-[#404248] font-extralight mb-8 lg:mb-10">
                {intl.formatMessage({
                  id: "howItWorks.headingPart1",
                  defaultMessage: "How It",
                })}{" "}
                <span className="text-[#00428A] font-normal">
                  {intl.formatMessage({
                    id: "howItWorks.headingPart2",
                    defaultMessage: "Works",
                  })}
                </span>
              </h1>

              <div className="flex items-center justify-center lg:gap-6 gap-4 lg:mb-10 mb-6">
                <div className="flex-shrink-0 lg:w-20 lg:h-20 w-14 h-14 pt-1">
                  <Image
                    src="/images/Chat.svg"
                    alt={intl.formatMessage({
                      id: "howItWorks.step1.title",
                      defaultMessage: "Share Health Problems",
                    })}
                    width={80}
                    height={80}
                  />
                </div>
                <div className="font-roboto w-full text-left">
                  <p className="text-[16px] lg:text-[18px] text-[#00428A] font-bold  md:leading-snug">
                    {intl.formatMessage({
                      id: "howItWorks.step1.title",
                      defaultMessage: "Share Health Problems",
                    })}
                  </p>
                  <p className=" text-[12px] lg:text-[16px] text-[#404248] font-light lg:leading-7 leading-6 mt-1">
                    {intl.formatMessage({
                      id: "howItWorks.step1.description",
                      defaultMessage: "Tell us what's happening-even if you're unsure or don't have reports yet.",
                    })}
                  </p>
                </div>
              </div>

              <div className="flex items-center lg:gap-6 gap-4 lg:mb-10 mb-6">
                <div className="flex-shrink-0 w-14 h-14 lg:w-20 lg:h-20 pt-1">
                  <Image
                    src="/images/Care-Coordinator.svg"
                    alt={intl.formatMessage({
                      id: "howItWorks.step2.title",
                      defaultMessage: "A Care Coordinator connects",
                    })}
                    width={80}
                    height={80}
                  />
                </div>
                <div className="font-roboto w-full text-left">
                  <p className="lg:text-[18px] text-[16px] text-[#00428A] font-bold leading-snug">
                    {intl.formatMessage({
                      id: "howItWorks.step2.title",
                      defaultMessage: "A Care Coordinator connects",
                    })}
                  </p>
                  <p className="lg:text-[16px] text-[12px] text-[#404248] font-light lg:leading-7 leading-6 mt-1">
                    {intl.formatMessage({
                      id: "howItWorks.step2.description",
                      defaultMessage: "A real person listens, understands the case, and answers your questions.",
                    })}
                  </p>
                </div>
              </div>

              <div className="flex items-center lg:gap-6 gap-4 lg:mb-10 mb-6">
                <div className="flex-shrink-0 w-14 h-14 lg:w-20 lg:h-20 pt-1">
                  <Image
                    src="/images/Options.svg"
                    alt={intl.formatMessage({
                      id: "howItWorks.step3.title",
                      defaultMessage: "Options are explained clearly",
                    })}
                    width={80}
                    height={80}
                  />
                </div>
                <div className="font-roboto w-full text-left">
                  <p className="lg:text-[18px] text-[16px] text-[#00428A] font-bold lg:leading-snug">
                    {intl.formatMessage({
                      id: "howItWorks.step3.title",
                      defaultMessage: "Options are explained clearly",
                    })}
                  </p>
                  <p className="lg:text-[16px] text-[12px] text-[#404248] font-light lg:leading-7 leading-6 mt-1">
                    {intl.formatMessage({
                      id: "howItWorks.step3.description",
                      defaultMessage: "Doctors, treatments, timelines and next steps - without jargon or pressure.",
                    })}
                  </p>
                </div>
              </div>

              <div className="flex items-center lg:gap-6 gap-4 mb-4 lg:mb-6">
                <div className="flex-shrink-0 w-14 h-14 lg:w-20 lg:h-20 pt-1">
                  <Image
                    src="/images/Care-support.svg"
                    alt={intl.formatMessage({
                      id: "howItWorks.step4.title",
                      defaultMessage: "Ongoing Support",
                    })}
                    width={80}
                    height={80}
                  />
                </div>
                <div className="font-roboto w-full text-left">
                  <p className="lg:text-[18px] text-[16px] text-[#00428A] font-bold lg:leading-snug">
                    {intl.formatMessage({
                      id: "howItWorks.step4.title",
                      defaultMessage: "Ongoing Support",
                    })}
                  </p>
                  <p className="lg:text-[16px] text-[12px] text-[#404248] font-light lg:leading-7 leading-6 mt-1">
                    {intl.formatMessage({
                      id: "howItWorks.step4.description",
                      defaultMessage: "From coordination to recovery follow-ups we stay involved so you're not managing this alone.",
                    })}
                  </p>
                </div>
              </div>

              <div className="bg-[#E8F4FC] w-fit max-w-full mt-0 lg:mt-4 rounded-lg py-2 lg:py-2 px-4 sm:px-6 lg:px-12 lg:mb-4 sm:mb-6 mb-6">
                <p className="text-[12px] sm:text-[14px] lg:text-[14px] leading-5 sm:leading-6 text-[#00428A] lg:font-bold font-semibold tracking-wide text-center sm:text-left break-words">
                  {intl.formatMessage({
                    id: "howItWorks.tagline",
                    defaultMessage: "No bots. No pressure. No obligation.",
                  })}
                </p>
              </div>

              <button
                className="font-roboto  w-full max-w-[360px] mx-auto sm:w-auto sm:max-w-none sm:mx-0 sm:ml-3 lg:ml-8 text-[10px] lg:text-[14px] sm:text-[12px] tracking-wide text-[#00428A] lg:font-medium font-normal py-2 sm:py-3 lg:py-3 px-10 sm:px-10 lg:px-6 border border-[#00428A] rounded-full hover:bg-[#003366] hover:text-white transition-colors text-center sm:whitespace-nowrap leading-5 sm:leading-normal"
                onClick = {()=>dispatch(openModal())}
              >
                {intl.formatMessage({
                  id: "howItWorks.button",
                  defaultMessage: "Tell us your health concern",
                })}
              </button>
            </div>

            {/* RIGHT COLUMN */}
            <div className=" flex flex-col items-left md:items-end justify-center gap-10 md:mt-20 mt-4 px-0 lg:pr-10">
              <Image
                src="/images/Female_doctor_patient.webp"
                alt="Doctor consultation"
                width={300}
                height={200}
                className=" w-full max-w-[250px] md:w-full md:max-w-[350px] md:h-auto object-cover mt-4 lg:mt-0"
              />
              <Image
                src="/images/Doctor-patient.svg"
                alt="Doctor with patient"
                width={300}
                height={250}
                className="hidden md:block w-full max-w-[350px] h-auto"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
